export const SEARCH_DEBOUNCE_MS = 600;
export const DEFAULT_PAGE_SIZE = 5;
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

export const QUERY_KEYS = {
  SOLD_OUT_ITEMS: 'sold-out-items',
} as const;
